import { useTranslation } from "react-i18next";
import "../styles/Legal.css";

export default function ShippingPolicy() {
  const { t } = useTranslation();

  const sections = t("shipping.sections", { returnObjects: true });

  return (
    <main className="legal-container no-copy">
      <h1>{t("shipping.title")}</h1>

      {Array.isArray(sections) &&
        sections.map((section, index) => (
          <section key={index}>
            <h2>{section.title}</h2>
            <p>{section.text}</p>
          </section>
        ))}
    </main>
  );
}